(() => {
  'use strict';

  const topicAliases = new Map([
    ['sample', 'sample'],
    ['standard', 'sample'],
    ['standard-product', 'sample'],
    ['standard-product-or-sample', 'sample'],
    ['bulk', 'bulk'],
    ['bulk-purchase', 'bulk'],
    ['wholesale', 'bulk'],
    ['oem', 'oem-odm'],
    ['odm', 'oem-odm'],
    ['oem-odm', 'oem-odm'],
    ['oem-or-odm-project', 'oem-odm'],
    ['product-selection', 'product-selection'],
    ['model-selection', 'product-selection'],
    ['product-selection-&-quotation', 'product-selection']
  ]);

  const initialize = (root) => {
    if (root.dataset.quoteInitialized === 'true') return;
    root.dataset.quoteInitialized = 'true';

    const status = root.querySelector('[data-quote-status]');
    if (status) status.focus({ preventScroll: true });

    const fields = root.querySelector('[data-quote-fields]');
    if (!fields || fields.dataset.hasErrors === 'true') return;

    const params = new URLSearchParams(window.location.search);
    const valueFor = (key) => (params.get(key) || '').trim();
    const fillBlank = (field, value) => {
      if (field && !field.value && value) field.value = value;
    };

    fields.querySelectorAll('[data-quote-param]').forEach((field) => {
      fillBlank(field, valueFor(field.dataset.quoteParam));
    });

    fillBlank(fields.querySelector('[data-quote-configuration]'), valueFor('region') || valueFor('variant'));

    const rawQuantity = valueFor('quantity');
    const quantity = Number(rawQuantity);
    if (/^\d+$/.test(rawQuantity) && Number.isSafeInteger(quantity) && quantity >= 1) {
      fillBlank(fields.querySelector('[data-quote-quantity]'), String(quantity));
    }

    const topic = fields.querySelector('[data-quote-topic]');
    const requestedTopic = valueFor('topic').toLowerCase().replace(/[\s_/]+/g, '-');
    const topicType = topicAliases.get(requestedTopic);
    if (topic && !topic.value && topicType) {
      const option = Array.from(topic.options).find((item) => item.dataset.quoteType === topicType);
      if (option) topic.value = option.value;
    }

    const setup = valueFor('setup');
    if (setup) {
      const prefix = root.dataset.quoteSetupPrefix;
      fillBlank(fields.querySelector('[data-quote-requirements]'), prefix ? prefix + '\n' + setup : setup);
    }
  };

  const initializeWithin = (scope) => {
    if (scope.matches && scope.matches('[data-hf-quote]')) initialize(scope);
    scope.querySelectorAll('[data-hf-quote]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
